import React from 'react'
import { Box, Button, CircularProgress, Typography } from '@mui/material'

export interface FetchProps {
  refetch(): void
  isRefetching: boolean
}

export const RefetchMessage = ({ refetch, isRefetching }: FetchProps): React.ReactElement => {
  return (
    <Box width="100%" alignItems="center" display="flex" justifyContent="center" flexDirection="column">
      <Typography variant="h4" sx={{ mb: 2 }}>
        Произошла ошибка при загрузке данных
      </Typography>

      <Button onClick={refetch}>{isRefetching ? <CircularProgress /> : 'Повторить попытку'}</Button>
    </Box>
  )
}
